import { TranslateService } from '@ngx-translate/core';
import { LanguageType } from './../models/enum.model';
import { GetInstructionModel } from './../models/get-instruction.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from './../../../environments/environment';
import { BuildingsPerManagementModel } from './../models/building-per-management.model';
import { BuildingsPerMunicipalityModel } from './../models/buildings-per-municipality.model';
import { BuildingsPerPeriodModel } from './../models/buildings-per-period.model';
import { DashboardModel } from './../models/dashboard.model';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  apiUrl = '/api/v1/dashboard';

  constructor(
    private http: HttpClient,
    private translateService: TranslateService
  ) {
    if (environment.production || environment.test) {
      this.apiUrl = `${environment.bffUrl}${this.apiUrl}`;
    }
  }

  getStatistics(language: string): Observable<DashboardModel> {
    return this.http.get<DashboardModel>(`${this.apiUrl}?language=${language}`);
  }

  getBuildingsPerPeriod(): Observable<BuildingsPerPeriodModel[]> {
    const language = this.translateService.currentLang;
    return this.http.get<BuildingsPerPeriodModel[]>(
      `${this.apiUrl}/buildings-per-period?language=${language}`
    );
  }

  getBuildingsPerMunicipality(): Observable<BuildingsPerMunicipalityModel[]> {
    const language = this.translateService.currentLang;
    return this.http.get<BuildingsPerMunicipalityModel[]>(
      `${this.apiUrl}/buildings-per-municipality?language=${language}`
    );
  }

  getBuildingsPerManagement(): Observable<BuildingsPerManagementModel[]> {
    const language = this.translateService.currentLang;
    return this.http.get<BuildingsPerManagementModel[]>(
      `${this.apiUrl}/buildings-per-management?language=${language}`
    );
  }

  getUserInstruction(language = 'en'): Observable<GetInstructionModel> {
    return this.http.get<GetInstructionModel>(
      `${this.apiUrl}/user-instruction?language=${language}`
    );
  }
}
